<div class="step-container flex justify-space-between " [ngClass]=" !rootScope.activeCustTab.VALData?.enableStepper ? 'disable-steps' : ''" >
    <div class="step-1 flex">
      <span class="step-val"   [ngClass]="{ 'active':rootScope.activeCustTab.VALData?.displayStep1Content || rootScope.activeCustTab.VALData?.step1Complete }">
        <span class="step-circle"  [ngClass]= "{ 'active' :rootScope.activeCustTab.VALData?.step1Active,'complete': rootScope.activeCustTab.VALData?.step1Complete }">
          <span *ngIf="rootScope.activeCustTab.VALData?.step1Complete"><f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon> </span>
          <span *ngIf="!rootScope.activeCustTab.VALData?.step1Complete" class="step-no">1</span></span></span><span>Go to ALIS</span>
    </div>
    <div class="step-2 flex">
     
      <span class="step-val" [ngClass]="{ 'active':rootScope.activeCustTab.VALData?.displayStep2Content || rootScope.activeCustTab.VALData?.step2Complete }">
      <span class="step-circle"  [ngClass]="{ 'active' :rootScope.activeCustTab.VALData?.step2Active,'complete': rootScope.activeCustTab.VALData?.step2Complete }">
        <span *ngIf="rootScope.activeCustTab.VALData?.step2Complete"><f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon> </span>
        <span class="step-no" *ngIf="!rootScope.activeCustTab.VALData?.step2Complete">2</span></span></span><span>Transfer the call </span>
    </div>
    <div class="step-3 flex">
      <div class="success " >
        <span class="step-val" [ngClass]="{ 'active':rootScope.activeCustTab.VALData?.displayStep3Content || rootScope.activeCustTab.VALData?.step3Complete || rootScope.activeCustTab.VALData?.step3Active }">
          <span class="step-circle"  [ngClass]="{ 'active' :rootScope.activeCustTab.VALData?.step3Active,
          'failure': (rootScope.activeCustTab.VALData?.step3Complete && !rootScope.activeCustTab.VALData?.displayStep3ContentAfterResponseSuccess),
          'complete': (rootScope.activeCustTab.VALData?.step3Complete && rootScope.activeCustTab.VALData?.displayStep3ContentAfterResponseSuccess) }">
          <span class="complete" *ngIf="rootScope.activeCustTab.VALData?.step3Complete && rootScope.activeCustTab.VALData?.displayStep3ContentAfterResponseSuccess"><f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span>
          <span class="failure" *ngIf="rootScope.activeCustTab.VALData?.step3Complete && !rootScope.activeCustTab.VALData?.displayStep3ContentAfterResponseSuccess"><f-icon icon-config='{"iconName": "xmark", "iconType": "solid", "iconSize": "s", "iconColor": "red"}'></f-icon></span>
          <span  *ngIf="!rootScope.activeCustTab.VALData?.step3Complete" class="step-no">3</span></span></span><span>Resume conversation</span>
      </div>

    
    </div>
  </div>

  <!-- content before step 1  -->
  <div class="steps-content" *ngIf="rootScope.activeCustTab.VALData.displayContentBeforeStep1">
    <div class="info-wrapper">
      <div class="info">Ensure there is a valid phone number on file.  If not, add one 
        then transfer to the Voluntary Account Lock app.</div>
    </div>
    
    <h4>Click on the Continue button to initiate the Account Lock process.</h4>
    <div class="btn-controls">
      <f-button text="Continue" title="Continue" (click)="initiateAccountLock()"type="button" variant="progressive" class=""></f-button>
    </div>
  </div>

 
  <!-- For step-1 content  -->
  <div class="steps-content " *ngIf="rootScope.activeCustTab.VALData.displayStep1Content">
    <div class="select-lang-method ">
      <p>Select the language for the Voluntary Account Lock app. Then, press the Account Lock App button and go to ALIS to transfer the customer to the Voluntary Account Lock app.</p>
      <mat-radio-group color="primary" class="account-selection hide1" disableRipple
        aria-label="Select an option" [(ngModel)]="selectedLanguage">
        <mat-radio-button class="delivery-method-button" *ngFor="let eachLang of valLangList"
          [value]="eachLang.code">
          {{eachLang.label}}
        </mat-radio-button>
      </mat-radio-group>
      <div class="btn-controls">
        <f-button text="Account Lock App" title="Account Lock App" (click)="moveToStep2()" [disabled]="disableAcountLockButton()" type="button" variant="progressive" class=""></f-button>
      </div>
    </div>
  </div>

 <!-- For step-2 content  -->
  <div class="steps-content"  *ngIf="rootScope.activeCustTab.VALData?.displayStep2Content">
    <p>Locate the Voluntary Account Lock app within ALIS by selecting “Consult”, searching for 
      “Lock”, and selecting “Account Lock Voice ALV, ALIS.</p>

      <div class="btn-controls">
        <f-button text="Back" title="Back" (click)="moveBackToStep1()" type="button" variant="progressive" class=""></f-button>
      </div>
    
  </div>


  <!-- For step-3 content  -->
 
  <div class="steps-content ">
    <div class="error-wrapper" *ngIf="rootScope.activeCustTab.VALData?.step3Active || rootScope.activeCustTab.VALData?.step3Complete">
      <p *ngIf="rootScope.activeCustTab.VALData?.step3Active"> 
         After the transfer is complete, the customer will return to the Care Portal. </p>

      <f-alert variant="success" [ngClass]=" rootScope.activeCustTab.VALData?.step3Complete && rootScope.activeCustTab.VALData?.displayStep3ContentAfterResponseSuccess ? 'hide1' : 'hide'">
        <strong> SUCCESS! </strong> {{ rootScope.activeCustTab.VALData.successMsg}}</f-alert>

      <f-alert variant="error" [ngClass]="rootScope.activeCustTab.VALData?.step3Complete && !rootScope.activeCustTab.VALData?.displayStep3ContentAfterResponseSuccess ? 'hide1' : 'hide'">
         <strong> FAILURE! </strong> The Voluntary Account Lock App encountered an error:  {{ rootScope.activeCustTab.VALData.errMsg}}. Please press the Account Lock App button to ensure the language is sent to the app, then try transferring the caller to the Voluntary Account Lock App again.
       </f-alert>
    </div>
  </div>